// src/roles.ts

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  CONTENT_ADMIN: 'content_admin',
  VENDOR_ADMIN: 'vendor_admin',
  VENDOR_CONTENT_ADMIN: 'vendor_content_admin',
  PARTNER_ADMIN: 'partner_admin',
  PARTNER_CONTENT_ADMIN: 'partner_content_admin',
  SYNAPSE_ACADEMY_ADMIN: 'synapse_academy_admin',
  SYNAPSE_STUDIO_ADMIN: 'synapse_studio_admin',
  SYNAPSE_ADVISOR_ADMIN: 'synapse_advisor_admin',
  COURSE_ADMIN: 'course_admin',
  USER: 'user',
};

/** Must stay in sync with `CONTENT_MANAGER_ROLES` in `functions/src/utils/token-utils.ts`. */
export const CONTENT_MANAGER_ROLES = [
  'super_admin',
  'admin',
  'content_admin',
  'content_curator',
  'vendor_content_curator',
  'partner_content_curator',
  'vendor_admin',
  'partner_admin',
  'academy_admin',
];

export const JABBA_THE_HUTT = [
  'matthew.geer@tdsynnex.com',
  'xavi.sarda@tdsynex.com',
];
